import _ from 'lodash';
/* eslint no-useless-escape:0 import/prefer-default-export:0 */
// import React, {useState, useEffect, useRef} from 'react';
// import {useIntl} from 'react-intl';

// function useEnhancedIntl() {
//   const intl = useIntl();

//   return intl;
// }

const reg =
  /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/;
export const isUrl = (path) => reg.test(path);

export const getPageQuery = () => URLSearchParams(window.location.href.split('?')[1]);

export const handleImage = (values, URL) => {
  const arr = _.without(_.split(values, '##'), '');
  let res = [];
  arr.forEach((i, index) => {
    res.push({
      uid: index,
      url: !(i.includes('https://') || i.includes('http://')) ? URL + i : i,
      path: i,
      name: i.substring(i.lastIndexOf('/') + 1),
    });
  });
  return res;
};

export const convertImage = (array) => {
  var temp = [];
  array.forEach((element) => {
    temp = _.concat(temp, element?.response?.data[0]?.url ?? element.path);
  });
  var res = _.uniq(temp).join('##');
  return res;
};

export const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const checkDateTime = (date1) => {
  date1 = new Date(date1);
  var date2 = new Date();
  return date2.getTime() > date1.getTime();
};

export const addMonthToTime = (dateTime, month) => {
  // if (checkDateTime(dateTime)) {
  //   const date = new Date();
  //   const newDate = new Date(date.setMonth(date.getMonth() + month));
  //   return newDate;
  // } else {
  // }
  const date = new Date(dateTime);
  const newDate = new Date(date.setMonth(date.getMonth() + month));
  return newDate;
};

export const addDayToTime = (dateTime, day) => {
  // if (checkDateTime(dateTime)) {
  //   const date = new Date();
  //   const newDate = new Date(date.setDate(date.getDate() + day));
  //   return newDate;
  // } else {
  // }
  const date = new Date(dateTime);
  const newDate = new Date(date.setDate(date.getDate() + day));
  return newDate;
};
export const getMonthAndDayDiff = (startDate, endDate) => {
  // Tính số miliseconds giữa hai ngày
  startDate = new Date(startDate);
  endDate = new Date(endDate);
  const timeDiff = Math.abs(endDate.getTime() - startDate.getTime());

  // Tính số ngày và số tháng từ số miliseconds đó
  const numDays = Math.floor(timeDiff / (1000 * 3600 * 24));
  const numMonths = Math.floor(numDays / 30);

  // Trả về số tháng và số ngày dưới dạng một đối tượng
  return {
    months: numMonths,
    days: numDays - numMonths * 30,
  };
};
export const getMonthAndDayDiffNow = (endDate) => {
  // Tính số miliseconds giữa hai ngày
  var startDate = new Date();
  //  // console.log(startDate)
  endDate = new Date(endDate);
  const timeDiff = Math.abs(endDate.getTime() - startDate.getTime());

  // Tính số ngày và số tháng từ số miliseconds đó
  const numDays = Math.floor(timeDiff / (1000 * 3600 * 24));
  const numMonths = Math.floor(numDays / 30);

  // Trả về số tháng và số ngày dưới dạng một đối tượng
  return {
    months: numMonths,
    days: numDays - numMonths * 30,
  };
};

export const dataTypeVehicle = (intl) => [
  {
    label: intl.formatMessage({id: 'VEHICLETYPE.VEHICLEGROUP.CAR'}),
    value: 'OTo',
    enum: 0b0001,
    regex:
      /(^[0-9]{2}[A-Za-z]{1}-?[0-9]{4,5}$)|(^[A-Za-z]{2}-?[0-9]{4,5}$)|(^[0-9]{2}-?[A-Za-z]{2}-?[0-9]{3}-?[0-9]{2}$)/,
    // regex:/(^[A-Z0-9]{2}-?[A-Z0-9]{1,3}-?[A-Z0-9]{1,2}$)|(^[A-Z0-9]{2,5}$)|(^[0-9]{2,3}-[0,9]{2}$)|(^[A-Z0-9]{2,3}-?[0-9]{4,5}$)/,
    format: intl.formatMessage({id: 'ULTILS_PLNB_CAR'}),
  },
  {
    label: intl.formatMessage({id: 'VEHICLETYPE.VEHICLEGROUP.MOTORBIKE'}),
    value: 'XeMay',
    enum: 0b0010,
    format: intl.formatMessage({id: 'ULTILS_PLNB_MOTORBIKE'}),
    regex:
      /(^[A-Za-z]{2}-?[0-9]{0,4}$)|(^[A-Za-z]{2}-?[0-9]{2}-?[0-9]{2}$)|(^[0-9]{2}-?[A-Z0-9a-z]{2,3}-?[A-Z0-9a-z]{2,3}-?[0-9]{2}$)|(^[0-9]{2}-[0-9]{3}-[A-Za-z]{2}$)/,
    // regex:/(^[A-Z]{2}-?[0-9]{0,4}$)|(^[0-9]{2}-?[A-Z0-9]{2,3}-?[A-Z0-9]{2,3}-?[0-9]{2}$)|(^[A-Z]{2}-?[0-9]{2}-?[0-9]{2}$)|(^[0-9]{3}-?[A-Z0-9]{2}$)/
  },
  {
    label: intl.formatMessage({id: 'VEHICLETYPE.VEHICLEGROUP.BIKE'}),
    value: 'XeDap',
    enum: 0b0100,
    format: '',
    regex: '',
  },
  {
    label: intl.formatMessage({id: 'VEHICLETYPE.VEHICLEGROUP.OTHER'}),
    value: 'None',
    enum: 0b0000,
    format: intl.formatMessage({id: 'ULTILS_PLNB_CARMOTOR'}),
    regex:
      /(^[0-9]{2}[A-Za-z]{1}-?[0-9]{4,5}$)|(^[A-Za-z]{2}-?[0-9]{4,5}$)|(^[0-9]{2}-?[A-Za-z]{2}-?[0-9]{3}-?[0-9]{2}$)|(^[A-Za-z]{2}-?[0-9]{0,4}$)|(^[A-Za-z]{2}-?[0-9]{2}-?[0-9]{2}$)|(^[0-9]{2}-?[A-Z0-9a-z]{2,3}-?[A-Z0-9a-z]{2,3}-?[0-9]{2}$)|(^[0-9]{2}-?[0-9]{3}-?[A-Za-z]{2}$)/,
  },
];

export const DATA_TT = (intl) => [
  {
    name: 'Xe thứ 1',
    id: 'donGiaThang',
  },
  {
    name: 'Xe thứ 2',
    id: 'donGiaThang2',
  },
  {
    name: 'Xe thứ 3',
    id: 'donGiaThang3',
  },
  {
    name: 'Xe thứ 4',
    id: 'donGiaThang4',
  },
  {
    name: 'Xe thứ 5',
    id: 'donGiaThang5',
  },
  {
    name: 'Xe thứ 6',
    id: 'donGiaThang6',
  },
  {
    name: 'Xe thứ 7',
    id: 'donGiaThang7',
  },
  {
    name: 'Xe thứ 8',
    id: 'donGiaThang8',
  },
  {
    name: 'Xe thứ 9',
    id: 'donGiaThang9',
  },
  {
    name: 'Xe thứ 10',
    id: 'donGiaThang10',
  },
];

// const PaymentMode = {
//   Postpaid: 0,
//   Prepaid: 1,
// };

export const EventTypeAction = [
  {id: 0, value: 'Đăng nhập'},
  {id: 1, value: 'Đăng xuất'},
  {id: 2, value: 'Thay đổi mật khẩu'},
  {id: 3, value: 'Thiết lập cấu hình hệ thống'},
  {id: 4, value: 'Thiết lập làn vào ra'},
  {id: 5, value: 'Thiết lập thiết bị'},
  {id: 6, value: 'Sửa số xe'},
  {id: 7, value: 'Mở barrier bằng tay'},
  {id: 8, value: 'Đóng barrier bằng tay'},
  {id: 9, value: 'Miễn phí gửi xe'},
  {id: 10, value: 'Xe vào ra hợp lệ'},
  {id: 11, value: 'Thay đổi dữ liệu'},
  {id: 12, value: 'Xóa dữ liệu'},
  {id: 13, value: 'Xả thẻ'},
];
